/** One labelled value in a facts grid; `saved` shows the value it would be under saved settings. */
export function Fact({ label, value, saved }: { label: string; value: string; saved?: string }) {
  return (
    <div className="min-w-0">
      <dt className="font-mono text-xs uppercase tracking-widest text-muted">{label}</dt>
      <dd className="mt-1 font-serif text-base text-heading">
        {value}
        {saved && saved !== value && <span className="ml-2 text-sm text-muted">saved: {saved}</span>}
      </dd>
    </div>
  )
}
